import { ROUTES } from '@ab-core/functions';
import type { ProductWithDetails } from '@ab-core/graphql/dist';
import { useProductsAvailabilitiesWithChannel } from '@ab-core/hooks-v2';
import getActiveCart from '@ab-core/hooks/cartNew/activeCart/useActiveCart';
import type { DefaultScalableProductCardProps } from '../cardLayout';
import { fallBackPosition, fallBackQuantityUnit, fallBackSalesUnit } from './fallBackStates';

export const useMappedProductToScalableProductV2Praemien = (
    products?: Array<ProductWithDetails>
): Array<DefaultScalableProductCardProps['product']> => {
    const { activeCart } = getActiveCart();

    const skus: Array<string> = [];
    products?.map((product) => skus.push(product.sku || ''));

    const { productsAvailabilitiesWithChannel } = useProductsAvailabilitiesWithChannel(
        {
            skus,
            cartId: activeCart?.id
        },
        !activeCart
    );

    const productList: Array<DefaultScalableProductCardProps['product']> = [];

    products?.map((product) => {
        const link = `${ROUTES.PRAEMIEN_SHOP_DETAIL}/${product.sku}`;

        const productAvailability = productsAvailabilitiesWithChannel?.find(
            (available) => available.sku === product.sku
        );

        const customDeliveryInfo =
            (productAvailability?.aggregatedMainChannelQuantity || 0) < 1
                ? 'Diese Prämie wird zeitnah für Sie beschafft.'
                : '';

        const maxQuantity = product.isLimitedQuantity ? productAvailability?.aggregatedMainChannelQuantity : undefined;

        productList.push({
            defaultQuantity: product.salesUnit || fallBackSalesUnit,
            sku: product.sku || '',
            information: { reach: product.reachInfo },
            tags: {
                product: {
                    isAbakus: product.bonus?.isAbakus,
                    isAbakusPlus: product.bonus?.isAbakusPlus,
                    topProduct: product.bonus?.isTopProduct,
                    isTecselect: product.bonus?.isTecselect,
                    isPromotion: product.bonus?.isPromotion,
                    scoreCardIndex: product.scoreCardIndex
                }
            },
            ids: {
                articleNumber: product.sku,
                ean: product.ean,
                customerArticleNumber: product.customerArticleNumber
            },
            image: {
                link,
                imgSrc: product.thumbnail || '',
                sku: product.sku,
                position: fallBackPosition
            },
            name: { link, text: product.productName, sku: product.sku, position: fallBackPosition },
            additionalLinks: {
                sku: product.sku,
                hasAccessories: product.hasAccessories,
                hasAlternatives: product.hasAlternatives
            },
            prices: {
                quantityUnit: product.quantityUnit || fallBackQuantityUnit,
                salesUnit: product.salesUnit || fallBackSalesUnit
            },
            availability: {
                availability: {
                    ...productAvailability
                },
                quantityUnit: product.quantityUnit || fallBackQuantityUnit,
                customDeliveryInfo
            },
            order: {
                packagingSize: product?.packagingSize || '',
                quantityUnit: product.quantityUnit || fallBackQuantityUnit,
                salesUnit: product.salesUnit || fallBackSalesUnit,
                sku: product.sku || '',
                isUnqualifiedContractProduct: product.isUnqualifiedContractProduct || false,
                position: fallBackPosition,
                maxQuantity
            },
            comparison: {
                sku: product.sku,
                title: product.productName,
                imageSrc: product.thumbnail || ''
            }
        });
    });

    return productList;
};
